import { router, usePage } from "@inertiajs/vue3";
import { onMounted, ref } from "vue";
import { useApiProxy } from "./useProxy";
import { CartItem } from "@/types";
import useDataLayer from "./useDataLayer";

export default function useCart() {
    const cart = ref<
        | {
            id: string;
            expires_in: number;
            created_at: string;
            items: {
                [key: string]: {
                    id: string;
                    item: string;
                    timestamp: string;
                    active?: boolean;
                };
            };
        }
        | undefined
    >(usePage().props.__cart as any);

    const removing = ref(false);

    const { registerRemoveFromCart } = useDataLayer()

    // router.on() registers a document-level listener, so defer to the browser
    // (onMounted) — running it during setup would crash SSR.
    onMounted(function () {
        router.on("finish", function (context) {
            cart.value = usePage().props.__cart as any;
        });
    });

    const removeFromCart = function (item: CartItem) {
        router.delete(route("remove.item", { item: item.id }), {
            onBefore: function () {
                removing.value = true;
            },
            onFinish: function (res) {
                removing.value = false;
                registerRemoveFromCart(item)
            },
        });
    };

    return {
        getTotal: function () {
            return Object.entries(cart.value?.items ?? {}).filter(
                ([_, item]) => item.active
            ).length;
        },

        inCart: function (itemId: string) {
            const cartItems = Object.entries(cart.value?.items ?? {})
                .map(([_, item]) => item)
                .filter((item) => item.active);
            return cartItems.filter((item) => item.id === itemId).length >= 1;
        },

        cart,

        removeFromCart,

        removing,
    };
}
